/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Dataroom_Deletefolderconfirm4Inputs */

const en_coinvestments_dataroom_deletefolderconfirm4 = /** @type {(inputs: Coinvestments_Dataroom_Deletefolderconfirm4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This folder and all its contents will be removed. This change won't take effect until you save.`)
};

/**
* | output |
* | --- |
* | "This folder and all its contents will be removed. This change won't take effect until you save." |
*
* @param {Coinvestments_Dataroom_Deletefolderconfirm4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_dataroom_deletefolderconfirm4 = /** @type {((inputs?: Coinvestments_Dataroom_Deletefolderconfirm4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Dataroom_Deletefolderconfirm4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_dataroom_deletefolderconfirm4(inputs)
});
export { coinvestments_dataroom_deletefolderconfirm4 as "coInvestments_dataRoom_deleteFolderConfirm" }